import React, { Fragment, useEffect } from 'react'
import { map } from 'lodash'
import { CloseIcon } from '../../../../../../components/icons'

import './styles.scss'

export default function TownsRankingComponent(props) {
  useEffect(() => {
    const clientId = props.match.params.id
    // eslint-disable-next-line camelcase
    props.getRankingByClientId({ clientId })
  }, [])

  const onClose = () => props.closeDrawer()

  return (
    <Fragment>
      <div className="drawer__header d__flex align__items__center">
        <h4 className="drawer__header__title">Towns Ranking</h4>
        <div className="drawer__header__close" onClick={onClose}>
          <button className="btn btn__link">
            <CloseIcon />
          </button>
        </div>
      </div>
      <div className="drawer__body">
          {props.towns && props.towns.length > 0 && props.isTownRated ? (
          <ul className="ranking__list">
            {map(props.towns, (town, townIndex) => (
              <li key={townIndex}>{`${townIndex + 1}. ${town.town_name}`}</li>
            ))}
          </ul>
          ) : (
            <div className="drawer__body__inner">
              <div className="blank__state__text">
                This client has not ranked any town yet. Once they rank then you
                will see them here.
              </div>
            </div>
          )}
      </div>
    </Fragment>
  )
}
